import React from "react";

const PrivacyPolicyComponent = () => {
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="container">
        <div className="main-body">
          <div className="row gutters-sm justify-content-center">
            <div className="col-md-12">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "30px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                }}
              >
                Our Privacy Policy
              </h1>
              <h4
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                  paddingBottom: "40px",
                  marginBottom: "40px",
                  borderBottom: " 1px solid #1ea3fe",
                }}
              >
                Please Read Them Carefully
              </h4>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                This website privacy policy (“Privacy Policy” or “Policy”)
                describe https://thelaundryportal.com. (herein after referred to
                as “Connection Hub Portal”, “Site” or “Website”) policy on the
                collection, use, and disclosure of information about you in
                connection with your use of the domain,
                https://thelaundryportal.com and all associated product sites
                listed on our Site. The terms “we”, “us” or “our”, refer to
                https://thelaundryportal.com. When you use the service available
                at our Website, you consent to our collection, use, and
                disclosure of information about you as described in this Privacy
                Policy. We reserve the right to update, change, amend or modify
                this Privacy Policy at any time and said changes will be
                effective upon posting. Every time there is a change, we will
                display a notice on our Site thereof. We shall also notify you
                by email. We will use your personal information in a manner
                consistent with the Privacy Policy in effect at the time you
                submitted the information unless you consent to the new or
                revised policy. In every respect, by using the Site, you agree
                to be bound by terms of this Privacy Policy.
              </p>
              <h3 class="wp-block-heading101">1. INTRODUCTION</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                1.1Your privacy is important to you and to us, so we’ll protect
                the information you share with us. To protect your privacy, the
                Site follows different principles in accordance with worldwide
                practices for customer privacy and data protection. 1.2 We at
                Connection Hub Portal are committed to respecting your online
                privacy and recognize your need for appropriate protection and
                management of any personally identifiable information (“Personal
                Information”) you share with us. For purpose of this Policy,
                Personal Information means any information that may be used to
                identify an individual, including, but not limited to, a first
                and last name, a home or other physical address and email
                address or other contact information, whether at work or at
                home. In general, you can visit the Site’s web pages without
                telling us who you are or revealing any Personal Information
                about yourself. If, however, Personal Information is reveled to
                us, we won’t sell or give away any content of your Personal
                Information to anyone and use state-of-the-art security measures
                to protect your information from unauthorized users.
              </p>
              <h3 class="wp-block-heading101">
                2. INFORMATION WE COLLECT AND HOW WE USE IT
              </h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                2.1 When you visit or use our service, we collect and store
                information about you, your computer or mobile device and your
                activities. This information may include, but is not limited to:
                <br /> <br />
                2.2.1 Your computer’s IP address; technical information about
                your computer or mobile device (such as type of device, web
                browser or operating system);
                <br /> <br />
                2.2.2 Your mobile device’s unique ID number (when available),
                your mobile device’s geographic location (specific geographic
                location if you’ve enabled collection of that information, or
                general geographic location automatically);
                <br /> <br />
                2.2.3 Your provided full name, email address, zip code and other
                information you may provide with your account, such as your
                gender and birth date;
                <br /> <br />
                2.2.4 How long you visited our service and which features you
                used;
                <br /> <br />
                2.2.5 You agree to comply with all applicable privacy and data
                protection regulations. Further, you agree to not use our
                service to send us sensitive information where unauthorized
                disclosure could cause material, severe, or catastrophic harm or
                impact to Connection Hub Portal, any data subjects or relying
                parties. Sensitive Information includes, passwords,
                authentication/authorization credentials, information under
                strict regulatory or contractual handling requirements (e.g.,
                PCI, HIPAA, and state and federal data security laws) such as,
                credit card information, credit card numbers, CIV numbers (three
                digit codes for Visa and MasterCard, four digit code for
                American Express) and magnetic stripe information, social
                security numbers, driver’s license numbers, passport numbers,
                government issued identification numbers, financial account
                information, health data, biometric data, personally
                identifiable information knowingly collected from children under
                the age of 13 or from online services directed toward children,
                real time geolocation data which can identify an individual,
                business secrets deemed highly confidential (e.g.,
                highly-confidential business strategies and communications,
                sensitive attorney-client privileged and confidential
                communications). We collect, store, and use your user data on
                our servers to provide you with the ability to better maintain
                and improve your services. We may also use data in an aggregated
                form for our own purposes.
                <br /> <br />
                2.3 Additionally, we shall not be liable for any loss or damage
                sustained by reason of any disclosure (inadvertent or otherwise)
                of any information concerning the user’s account and / or
                information relating to or regarding online transactions using
                credit cards / debit cards and / or their verification process
                and particulars nor for any error, omission or inaccuracy with
                respect to any information so disclosed and used whether or not
                in pursuance of a legal process or otherwise.
                <br /> <br />
                2.4 We use the information to improve the Service’s
                functionality, quality and also personalize your experience. We
                also use this information to display relevant advertising,
                provide support, message you, and comply with legal obligations.
                <br /> <br />
                2.5 Please note that some of this information is automatically
                collected without you voluntarily choosing to provide this
                information to us.
              </p>
              <h3 class="wp-block-heading101">3. NOTICE</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                We will ask you when we need information that personally
                identifies you or allows us to contact you. Generally, this
                information is requested when you create a registration or login
                ID on the Site or when you connect or browse connected sites,
                linked or listed on our Website, or join a limited-access
                premium site. We use your Personal Information for four primary
                purposes: a. to make the site easier for you to use by not
                having to enter information more than once; b. to help you
                quickly find services or information that you are looking for;
                c. to help us create content most relevant to you; d. to alert
                you to special offers, updated information and other new
                services available on our Site.
              </p>
              <h3 class="wp-block-heading101">4. THIRD-PARTY SERVICES</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                Our services are designed to allow you to assign tasks to field
                workers, communicate with your field workers and customers
                (“Users”), and view information pertaining to your field
                workers’ activity. Connection Hub Portal does this in part using
                GPS and other sensors on devices running our software products
                and applications. Some information is automatically collected
                from or about your Users and field workers when you use our
                services and may include, for example, geographic coordinates,
                phone numbers, names, and addresses. Integrated Services. For
                the use of Integrated Services you may be given the option to
                access or register for the Service through the use of your
                username and passwords for certain services provided by third
                parties (each, an “Integrated Service”), such as through the use
                of your Google account, or otherwise have the option to
                authorize an Integrated Service to provide Personal Data or
                other information to us. By authorizing us to connect with an
                Integrated Service, you authorize us to access & store your
                name, email address(es) and other information that the
                Integrated Service makes available to us, and to use and
                disclose it in accordance with this Policy. You should check
                your privacy settings on each Integrated Service to understand
                what information that Integrated Service makes available to us,
                and make changes as appropriate.
              </p>
              <h3 class="wp-block-heading101">5. CONSENT</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                5.1 If you choose not to register or provide Personal
                Information, you can still use most of the Website. But you will
                not be able to access areas that require registration. If you
                decide to register, you will be able to select the kinds of
                information you want to receive from us by subscribing to
                various services, like our electronic newsletters. If you do not
                want us to communicate with you about other offers regarding the
                Site’s programs, events, or Services by email, postal mail, or
                telephone, you may select the option stating that you do not
                wish to receive messages from us.
              </p>
              <h3 class="wp-block-heading101">4. ACCESS</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                We will provide you with the means to ensure that your Personal
                Information is correct and current. You may review and update
                this information at any time at the login section. There, you
                can: a. view and edit personal information you have already
                given us; b. tell us whether you want us to send you marketing
                information, or whether you want third parties to send you their
                offers by postal mail; c. sign up for electronic newsletters
                about our services and products; and d. Register. Once you
                register, you won’t need to do it again. Wherever you go on the
                Site, your information stays with you.
              </p>
              <h3 class="wp-block-heading101">7. SECURITY</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                7.1 The Site has taken strong measures to protect the security
                of your Personal Information and to ensure that your choices for
                its intended use are honored. We take strong precautions to
                protect your data from loss, misuse, unauthorized access or
                disclosure, alteration, or destruction.
                <br /> <br />
                7.2 You also have a significant role in protecting your
                information. No one can see or edit your Personal Information
                without knowing your user name and password, so do not share
                these with others.
                <br /> <br />
                7.3 Data Security: In addition to the above, Connection Hub
                Portal will maintain security procedures and practices to store
                in a secure fashion and protect all personally identifiable
                information regarding the end user (“PII”) that is collected by
                Connection Hub Portal and stored in a database owned or
                controlled by Connection Hub Portal (the “Database”), against
                accidental or unlawful destruction or loss, unauthorized
                disclosure or access. Such security procedures and practices
                shall be implemented in accordance with all applicable data
                protection laws and shall be appropriate to the nature of the
                information collected and shall be aligned with industry
                standard practices for the management, transport, and storage of
                PII.
                <br /> <br />
                7.4 We agree to adhere to the Privacy Shield Principles, which
                were identified in our organization’s self-certification
                submission under “Other Covered Entities”.
              </p>
              <h3 class="wp-block-heading101">8. NOTICE TO PARENTS</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                8.1 We want to help you guard your children’s privacy. We
                encourage you to talk to your children (below 13 years) about
                safe and responsible use of their Personal Information while
                using our Site. The Site does not publish content that is
                harmful, derogatory or pornographic in nature. However, the
                Website shall not incur any liability should your children
                provide us any Personal Information without parental consent. If
                you become aware that a child has provided us with personal
                information without parental consent, please get in touch with
                us through our contact us page. If we become aware that a child
                under 13 has provided us with Personal Information without
                parental consent, we take steps to remove such information and
                terminate the child’s account.
              </p>
              <h3 class="wp-block-heading101">9. REGISTRATION</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                9.1 When you login to the Site’s secure pages, we may ask you to
                register yourself electronically. When you do, we merge your
                registration information with any information you’ve already
                left with us (we call that information your personal profile).
                If you haven’t previously registered with us, we create a
                personal profile for you from your registration information. If
                you ever want to review or update that information, you can
                visit the Site, click on update profile, and edit any of the
                Personal Information in your profile.
              </p>
              <h3 class="wp-block-heading101">10. CUSTOMER PROFILES</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                10.1 As mentioned above, every registered customer has a unique
                personal profile. Each profile is assigned a unique personal
                identification number, which helps us ensure that only you can
                access your profile.
                <br /> <br />
                10.2 Cookies: When you visit our Site, we may place “cookies” on
                your computer to recognize you. We do this to store your
                preferences, collect statistical data and track your use of our
                service. Cookies are widely used, and most web browsers are
                configured initially to accept cookies automatically. If you
                prefer not to accept cookies, you may adjust and configure your
                browser settings accordingly. However, if you turn off cookies,
                or refuse to accept a request to place a cookie, some features
                and services on the Site may not function properly. Ad companies
                (including but not limited to Google and Facebook) may also
                place cookies on your computer to track your activities across
                various sites so that they can display targeted advertisements.
                In addition to above you are requested to read our cookie policy
                at https://thelaundryportal.com/privacy-policy/.
                <br /> <br />
                10.3 We provide you with access to your user data and ability to
                delete any of your user data. We also take commercially
                reasonable steps to safeguard user data. We may also collect
                registration and other information about you as our customer
                through our Site. Our collection and use of information
                collected about you on our website is governed by this Privacy
                Policy.
              </p>
              <h3 class="wp-block-heading101">
                11. What we do with the information you share
              </h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                11.1 When you join us, you provide us with your contact
                information, including your name and email address. We use this
                information to send you updates about our services,
                questionnaires to measure your satisfaction with our service and
                announcements about new and exciting services that we offer.
                <br /> <br />
                11.2 We will disclose your Personal Information, without notice,
                only if required to do so by law or in the good faith belief
                that such action is necessary to: (a) confirm to the edicts of
                the law or comply with legal process served on the Site; (b)
                protect and defend the rights or property of Jungle works; and
                (c) act in urgent circumstances to protect the personal safety
                of users of Jungle works or the public.
              </p>
              <h3 class="wp-block-heading101">
                12. INFORMATION SHARING AND DISCLOSURE
              </h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                12.1 We do not rent or sell Personal Information about you with
                other people (save with your consent) or non-affiliated
                companies, except to provide services you’ve requested, under
                the following circumstances:
              </p>
              <ul>
                <li>
                  We respond to court orders, legal proceedings or to establish
                  or exercise our legal rights or defend against legal claims.
                </li>
                <li>
                  We believe it is necessary to share information in order to
                  investigate, prevent, or take action regarding illegal
                  activities, suspected fraud, situations involving potential
                  threats to the physical safety of any person, violations of
                  the Website’s terms of use, or as otherwise required by law.
                </li>
                <li>
                  We shall transfer information about you only if we are
                  acquired by another company or individual. In this event, the
                  Website will notify you before information about you is
                  transferred and becomes subject to a different privacy policy.
                </li>
                <li>
                  We respond to court orders, legal proceedings or to establish
                  or exercise our legal rights or defend against legal claims.
                </li>
                <li>
                  We may need to contact you to comply or co-operate with a
                  legal request. For this purpose, we will use the email address
                  provided to us by you. All communications sent by us at such
                  email address shall be deemed to have been communicated to
                  you.
                </li>
              </ul>
              <h3 class="wp-block-heading101">
                13. CONFIDENTIALITY AND SECURITY
              </h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                13.1 We limit access to Personal Information about you to
                employees who we believe reasonably need to come into contact
                with that information to provide products or services to you or
                in order to do their jobs.
                <br /> <br />
                13.2 We have physical, electronic, and procedural safeguards
                that comply with the laws all over the world; we provide our
                services to protect personal information about you. We seek to
                ensure compliance with applicable technology laws to ensure the
                protection and preservation of your privacy. Additionally, we
                follow generally accepted industry standards to protect the
                Personal Information submitted to us, both during transmission
                and once we receive it. However, no method of transmission over
                the Internet or via mobile device, or method of electronic
                storage, is 100% secure. Therefore, while we strive to use
                commercially acceptable means to protect your Personal
                Information, we cannot guarantee its absolute security.
              </p>

              <h3 class="wp-block-heading101">14. YOUR CONSENT</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                14.1 By using the Website, you consent to the terms of our
                Privacy Policy and to the Site’s processing of Personal
                Information for the purposes given above as well as those
                explained at https://thelaundryportal.com.
              </p>

              <h3 class="wp-block-heading101">15. COOKIES</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                15.1 Cookies are small text files that can be stored on your
                local computer. They are not always personal data. They are
                considered personal data, only when they are unique and clearly
                identifiable. Even then, they cannot identify you as a person,
                they rather identify your computer or browser. You are informed
                about their usage by a notice during your first visit of this
                site.
              </p>

              <h3 class="wp-block-heading101">16. GOOGLE ANALYTICS</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                16.1 We use services of Google Analytics on this website in
                order to get anonymised statistics about traffic on this
                website. This service is using the previously mentioned cookies
                and may also store information about the IP address of the
                visitor. The relevant cookies are _ga, _gid, _gat and they can
                be stored for up to 2 years.
                <br />
                <br />
                More information can be found on the Google page dedicated to
                privacy policy.
              </p>

              <h3 class="wp-block-heading101">CONTACT INFORMATION</h3>
              <p style={{ fontSize: "18px",textAlign:"justify"}}>
                We welcome your comments regarding this privacy statement at the
                contact address given at the website. Should there be any
                concerns about contravention of this Privacy Policy, we will
                employ all commercially reasonable efforts to address the same.
                The terms in this Policy may be changed by us at any time.
                Connection Hub Portal is free to offer its services to any
                client/prospective client without restriction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyComponent;
